import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-navbar',
  imports: [],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css'
})
export class NavbarComponent {

  constructor(
    private router: Router,
    private  toastr: ToastrService
  ){}

  logout(){
    localStorage.removeItem('isLogin')
    this.toastr.success('Logout successful')
    this.router.navigate(['/auth/login'])
  }
}
